import { createSlice } from '@reduxjs/toolkit';

/**
 * Tracks whether the Azure session has expired and needs re-authentication.
 *
 * The RTK Query base query flips `sessionExpired` on a 401.
 * `AppWithAzureAuth` observes this flag and performs the recovery, then
 * clears it via `sessionRecovered`.
 */
export interface AuthState {
  sessionExpired: boolean;
}

const initialState: AuthState = {
  sessionExpired: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    sessionExpired: (state) => {
      state.sessionExpired = true;
    },
    sessionRecovered: (state) => {
      state.sessionExpired = false;
    },
  },
});

export const { sessionExpired, sessionRecovered } = authSlice.actions;
export default authSlice.reducer;
